<template>
  <div class="pie-box">
    <div :class="className" :id="id" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
export default {
  name: "HollowPie",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Object,
      default() {
        return {};
      }
    },
      rich:{
        type:Object,
          default(){
            return {
                yellow: {
                    color: "#ffc72b",
                    fontSize: 11 * 1,
                    padding: [5, 4],
                    align: 'center'
                },
                total: {
                    color: "#ffc72b",
                    fontSize: 11 * 1,
                    align: 'center'
                },
                white: {
                    color: "#fff",
                    align: 'center',
                    fontSize: 14 * 1,
                    padding: [11, 0]
                },
                blue: {
                    color: '#49dff0',
                    fontSize: 10 * 1,
                    align: 'center'
                },
                hr: {
                    borderColor: '#0b5263',
                    width: '100%',
                    borderWidth: 1,
                    height: 0,
                }
            }
          }
      }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      let me = this
        /****update by zy, 20190830 改为传入 */
/*      var rich = {
          type:Object,
          default(){
              return {
                  yellow: {
                      color: "#ffc72b",
                      fontSize: 11 * 1,
                      padding: [5, 4],
                      align: 'center'
                  },
                  total: {
                      color: "#ffc72b",
                      fontSize: 11 * 1,
                      align: 'center'
                  },
                  white: {
                      color: "#fff",
                      align: 'center',
                      fontSize: 14 * 1,
                      padding: [11, 0]
                  },
                  blue: {
                      color: '#49dff0',
                      fontSize: 10 * 1,
                      align: 'center'
                  },
                  hr: {
                      borderColor: '#0b5263',
                      width: '100%',
                      borderWidth: 1,
                      height: 0,
                  }
              }
          }
      }*/
      var rich = this.rich

      var option = {
        backgroundColor: "rgba(0,0,0,0)",
//        title: {
//          text:'总考生数',
//          left:'center',
//          top:'53%',
//          padding:[24,0],
//          textStyle:{
//            color:'#fff',
//            fontSize:18 * 1,
//            align:'center'
//          }
//        },
        legend: {
          selectedMode:false,
//          formatter: function(name) {
//            var total = 0; //各科正确率总和
//            var averagePercent; //综合正确率
//            me.chartData.data.forEach(function(value, index, array) {
//              total += value.value;
//            });
//            return '{total|' + total + '}';
//          },
//          data: [me.chartData.data[0].name],
           data: [''],
           itemGap: 50,
          left: 'center',
          top: 'center',
          icon: 'none',
          align:'center',
          textStyle: {
            color: "#fff",
            fontSize: 20,
            rich: rich
          },
        },
        series: [{
          name: '',
          type: 'pie',
          radius: ['50%', '60%'],
          hoverAnimation: true,
          color: ['#c487ee', '#deb140', '#49dff0', '#034079', '#6f81da', '#00ffb4', '#fff333'],
          label: {
            normal: {
              formatter: function(params, ticket, callback) {
                var total = 0;
                var percent = 0;
                me.chartData.data.forEach(function(value, index, array) {
                  total += value.value;
                });
                percent = ((params.value / total) * 100).toFixed(1);
                return '{white|' + params.name + '}\n{hr|}\n{yellow|' + params.value + '}\n{blue|' + percent + '%}';
              },
              rich: rich
            },
          },
          labelLine: {
            normal: {
              length: 20 * 1,
              length2: 0,
              lineStyle: {
                color: '#0b5263'
              }
            }
          },
          data: me.chartData.data
        }]
      }

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<!--<style scoped lang="less">-->
<!--.pie-box {-->
  <!--width: 100%;-->
  <!--height: 100%;-->
  <!--position: relative;-->
<!--}-->
<!--</style>-->
